import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "i18n-fe";

// #3152 - the one dialog the other-deduction recording flow uses. Two kinds:
//  - "confirm": a deduction whose catalog note says "not for each recurrence"
//    (USDF Forbidden Movement) is already on the sheet; recording a second is
//    allowed (a DIFFERENT movement is charged again) but must be deliberate.
//  - "problem": planOtherDeduction refused. From ScoringForm today only "cap"
//    (and a defensive "unknown"/"mismatch") can occur: the gavel-menu section
//    only renders when the cached Test row carries otherDeductions, so the
//    client cannot tell an un-enriched row from a test that prints none.
//    The "notEnriched" copy is NOT reachable from ScoringForm: the server's
//    `problems` for a quarantined PUT (where notEnriched is actually learned)
//    surface through QuarantineNotices.jsx (#3155) with its own copy, so this
//    dialog's notEnriched branch stays only as a unit-tested defensive case.
//    Said in scribe language with an OK, never a dead end: scribe is a kiosk.
//    Every i18n key is a static literal.
export default function OtherDeductionDialog({ state, onClose, onConfirm }) {
  const { t } = useTranslation("score");
  const { open, kind, reason, label, max } = state;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      data-testid="other-deduction-dialog"
    >
      <DialogTitle>
        {kind === "confirm"
          ? t("scoring.otherDeductionConfirmTitle", { label })
          : t("scoring.otherDeductionProblemTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {kind === "confirm" && t("scoring.otherDeductionConfirmBody", { label })}
          {kind === "problem" &&
            reason === "notEnriched" &&
            t("scoring.otherDeductionProblemNotEnriched", { label })}
          {kind === "problem" &&
            reason === "cap" &&
            t("scoring.otherDeductionProblemCap", { label, max })}
          {kind === "problem" &&
            reason !== "notEnriched" &&
            reason !== "cap" &&
            t("scoring.otherDeductionProblemOther", { label })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {kind === "confirm" ? (
          <>
            <Button color="inherit" onClick={onClose}>
              {t("scoring.otherDeductionConfirmCancel")}
            </Button>
            <Button
              variant="contained"
              data-testid="other-deduction-confirm"
              onClick={onConfirm}
            >
              {t("scoring.otherDeductionConfirmRecord")}
            </Button>
          </>
        ) : (
          <Button variant="contained" onClick={onClose}>
            {t("scoring.otherDeductionProblemOk")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
